import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { Formik } from 'formik'
import { LoadingButton } from '@mui/lab'
import { ExplanationAccordion } from 'components'
import { SettingsAutoArchiveAfterImportCancellationDateDto } from 'dtos'
import { autoArchiveAfterImportCancellationDateValidationSchema } from 'dtos/settingsAutoArchiveAfterImportCancellationDateDto'

interface AutoArchiveAfterImportAddEditDialogProps {
  initialValues: SettingsAutoArchiveAfterImportCancellationDateDto
  open: boolean
  isLoading?: boolean
  onClose: () => void
  onSave: (values: SettingsAutoArchiveAfterImportCancellationDateDto) => void
}

export default function AutoArchiveAfterImportAddEditDialog({
  isLoading,
  initialValues,
  open,
  onClose,
  onSave
}: AutoArchiveAfterImportAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={autoArchiveAfterImportCancellationDateValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Auto Archive After Import Cancellation Date</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(
                        touched.autoArchiveNumberOfDaysAfterCancelImport && errors.autoArchiveNumberOfDaysAfterCancelImport
                      )}
                      helperText={
                        touched.autoArchiveNumberOfDaysAfterCancelImport && errors.autoArchiveNumberOfDaysAfterCancelImport
                      }
                      label='Days after Cancel Import'
                      name='autoArchiveNumberOfDaysAfterCancelImport'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.autoArchiveNumberOfDaysAfterCancelImport}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>
                    ||All fields are required. ||Vehicle imports that were cancelled because they were never brought across the
                    border get auto archived after the entered number of days. ||
                  </ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading || isSubmitting} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
